import gql from 'graphql-tag';
import ReactFullStory, { FullStoryAPI } from 'react-fullstory';
import React, { useEffect } from 'react';

import { isBrowser, isProduction } from '@zapier/common-utils';

import { Query } from '@apollo/react-components'; // eslint-disable-line no-restricted-syntax

export const FULLSTORY_ORG = '1XM';

const fullStoryQuery = gql`
  query FullStoryQuery {
    currentUserV2 {
      id
      fullName
      email
    }
  }
`;

const isInFrame = () => {
  try {
    return window.top !== window.self;
  } catch (e) {
    return true;
  }
};

const FullStoryScript = props => {
  const { user } = props;

  // If we're loading this page from inside an iframe it's on another partner's
  // site. Therefore, we include this global var to make sure that fullstory
  // records in the frame.
  // See https://help.fullstory.com/using/recording-iframes
  useEffect(() => {
    if (typeof window !== 'undefined' && isInFrame()) {
      window._fs_is_outer_script = true;
    }
  }, []);

  useEffect(() => {
    // Sets the identity of the user in Fullstory
    if (user && isProduction()) {
      FullStoryAPI('identify', user.id, {
        displayName: user.fullName,
        email: user.email,
      });
    }
  }, [user]);

  return <ReactFullStory org={FULLSTORY_ORG} />;
};

const FullStoryMount = () => {
  console.info(`Mounting FullStory integration...`);
  return (
    <Query query={fullStoryQuery} ssr={isBrowser()}>
      {result => {
        const { loading, error } = result;
        const { currentUserV2 } = result.data || {};

        if (loading || error) {
          return null;
        }

        return <FullStoryScript user={currentUserV2} />;
      }}
    </Query>
  );
};

const FullStoryContainer = () => {
  if (!isProduction()) {
    console.info(`Would have mounted FullStory integration...`);
    return null;
  }

  return <FullStoryMount />;
};

export default FullStoryContainer;
